import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface Supervisor {
  id: string;
  email: string;
  display_name: string | null;
}

export const useSupervisors = (excludeUserId?: string) => {
  const { tenantId, user } = useAuth();

  return useQuery({
    queryKey: ['supervisors', tenantId, excludeUserId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('usuarios_perfis')
        .select('id, email, display_name')
        .eq('tenant_id', tenantId)
        .eq('ativo', true)
        .order('email', { ascending: true });

      if (error) throw error;

      const supervisors: Supervisor[] = (data || [])
        .filter((u) => u.id !== excludeUserId)
        .map((u) => ({
          id: u.id,
          email: u.email,
          display_name: u.display_name || u.email.split('@')[0],
        }));

      return supervisors;
    },
    enabled: !!tenantId && !!user,
  });
};
